import React from 'react'

const Empty = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
  >
    <image
      x="0px"
      y="0px"
      width="1em"
      height="1em"
      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=
"
    />
  </svg>

)

export default Empty
